'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (process.env.BROWSER) {
  require('./Category.css');
}

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'category', style: props.style },
    props.children
  );
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Category.js
 ** module id = 795
 ** module chunks = 0
 **/